<script setup>
import { usePedidoStore } from '@/stores/pedido';
import PedidoCard from './PedidoCard.vue';
import KanbanColumn from '@/components/common/KanbanColumn.vue';

const props = defineProps({
  column: {
    type: Object,
    required: true
  }
});

const pedidoStore = usePedidoStore();

const handleLoadMoreBuscarMaisPedidos = (columnKey) => {
  pedidoStore.buscarPedidosPorColuna(columnKey, { 
    append: true, 
    loadMore: true,
    silent: true
  });
};
</script>

<template>
  <KanbanColumn
    :column="props.column"
    :items="pedidoStore.getPedidosByStatus(props.column.key)"
    :loading="pedidoStore.isColumnLoading(props.column.key)"
    :has-more-to-load="pedidoStore.existemPedidosParaCarregar(props.column.key)"
    :column-total="pedidoStore.getColumnTotal(props.column.key)"
    loading-text="Carregando pedidos..."
    loading-more-text="Carregando mais pedidos..."
    empty-text="Nenhum pedido neste status"
    end-text="Fim da lista"
    @load-more="handleLoadMoreBuscarMaisPedidos"
  >
    <template #default="{ items }">
      <PedidoCard
        v-for="pedido in items"
        :key="`${pedido.id}-${pedido.updated_at || Date.now()}`"
        :pedido="pedido"
      />
    </template>
  </KanbanColumn>
</template>
